import {Component, model, output, signal} from '@angular/core';
import {ImageCroppedEvent, ImageCropperComponent} from 'ngx-image-cropper';
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {Camera, CameraResultType} from '@capacitor/camera';
import {environment} from 'src/app/environments/environment';

@Component({
  selector: 'app-profile-picture-editor',
  imports: [
    GenericButtonComponent,
    ImageCropperComponent
],
  templateUrl: './profile-picture-editor.component.html',
  styleUrl: './profile-picture-editor.component.css'
})
export class ProfilePictureEditorComponent {

  currentImageUrl = model<string>();
  updateImageUrl = output<string | undefined>();

  originalImageUrl = signal<string | undefined>(undefined);

  async takeProfilePicture() {
    if (!['web', ''].includes(environment.platform)) {
      await Camera.requestPermissions({permissions: ['camera', 'photos']});
    }

    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.Uri,
        saveToGallery: false,
        width: 1320,
        height: 1320,
        webUseInput: true
      });

      var imageUrl = image.webPath;
      this.originalImageUrl.set(imageUrl);
    } catch (error) {
      console.log("Unable to get photo", error);
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    const objectUrl = event.objectUrl;
    if (!objectUrl) return;

    this.updateImageUrl.emit(objectUrl);
  }

  clearProfilePicture() {
    if (!window.confirm("Are you sure you want to clear the current profile picture?")) return;

    this.currentImageUrl.set(undefined);
    this.originalImageUrl.set(undefined);
    this.updateImageUrl.emit(undefined);
  }
}
